// ✅ App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./Dashboard/Login";
import MultiRolePanel from "./pages/MultiRolePanel"; // ✅ layout (sidebar + header)
import FormWizardTesting from "./Components/FormWizardTesting";
import UserViewPage from "./Dashboard/UserViewPage"; 

// 🔒 Private Route wrapper
const PrivateRoute = ({ children }) => {
  const authUserString = sessionStorage.getItem("authUserData1");
  const authUser = authUserString ? JSON.parse(authUserString) : null;

  // If no session, redirect to login
  if (!authUser || !authUser?.data || authUser?.data?.length === 0) {
    return <Navigate to="/login" replace />;
  }

  // Otherwise allow access
  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Default redirect to login */}
        <Route path="/" element={<Navigate to="/login" />} />

        {/* Login page */}
        <Route path="/login" element={<LoginPage />} />

        {/* ✅ Protected main dashboard layout */}
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute>
              <MultiRolePanel />
            </PrivateRoute>
          }
        />

        {/* ✅ Protected entity route */}
        <Route
          path="/dashboard/entity/:id"
          element={
            <PrivateRoute>
              <UserViewPage />
            </PrivateRoute>
          }
        />

        {/* ✅ Protected enterprise create form */}
        <Route
          path="/dashboard/enterprise/create"
          element={
            <PrivateRoute>
              <FormWizardTesting />
            </PrivateRoute>
          }
        />

        {/* Catch all: redirect unknown routes */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;


// // ✅ App.jsx
// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import LoginPage from "./Dashboard/Login";
// import MultiRolePanel from "./pages/MultiRolePanel"; // ✅ layout (sidebar + header)
// import FormWizardTesting from "./Components/FormWizardTesting";
// import UserViewPage from "./Dashboard/UserViewPage"; 

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Navigate to="/login" />} />
//         <Route path="/login" element={<LoginPage />} />

//         {/* ✅ MAIN DASHBOARD ROUTER */}
//         <Route path="/dashboard/*" element={<MultiRolePanel />} />

//         {/* Example extra routes */}
//         <Route path="/dashboard/entity/:id" element={<UserViewPage />} />
//         <Route path="/dashboard/enterprise/create" element={<FormWizardTesting />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;



// import UserViewPage from "./Dashboard/UserViewPage"; // ✅ new import
// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import LoginPage from "./Dashboard/Login";
// import MultiRolePanel from "./pages/MultiRolePanel";
// import Dashboards from "./Dashboard/Dashboards";
// import Entities from "./Dashboard/Entities";
// import Keys from "./Dashboard/Keys";
// import Inventory from "./Dashboard/Inventory";
// import Orders from "./Dashboard/Orders";
// import Payments from "./Dashboard/Payments";
// import Balances from "./Dashboard/Balance";
// import Support from "./Dashboard/Support";
// import Account from "./Dashboard/Account";
// import EnterpriseUI from "./Dashboard/EnterpriseUI";
// import ActivationReport from "./Dashboard/ActivationReport";
// import FormWizardTesting from "./Components/FormWizardTesting";
// import Enterprise from "./Dashboard/Enterprise";
// import Devices from "./Dashboard/Devices";
// import CustomerCards from "./Components/CustomerCard";
// import DeletedCustomers from "./Dashboard/DeletedCustomers";

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Navigate to="/login" />} />
//         <Route path="/login" element={<LoginPage />} />

//         <Route path="/dashboard/*" element={<MultiRolePanel />}>
//           <Route index element={<Dashboards />} />
//           <Route path="entities" element={<Entities />} />
//           <Route path="keys" element={<Keys />} />
//           <Route path="inventory" element={<Inventory />} />
//           <Route path="devices" element={<Devices/>}/>
//           <Route path="customers" element={<CustomerCards />}/>
//           <Route path="recover" element={<DeletedCustomers/>}/>
//           <Route path="report" element={<ActivationReport />} />
//           <Route path="orders" element={<Orders />} />
//           <Route path="payments" element={<Payments />} />
//           <Route path="balances" element={<Balances />} />
//           <Route path="support" element={<Support />} />
//           <Route path="account" element={<Account />} />
//           <Route path="enterprises" element={<EnterpriseUI />} />
//           <Route path="enterprise/create" element={<FormWizardTesting />} />

//           {/* ✅ NEW USER VIEW PAGE */}
//           <Route path="entity/:id" element={<UserViewPage />} />
//         </Route>
//       </Routes>
//     </Router>
//   );
// }

// export default App;



// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import LoginPage from "./Dashboard/Login";
// import MultiRolePanel from "./pages/MultiRolePanel";
// import Dashboards from "./Dashboard/Dashboards";
// import Entities from "./Dashboard/Entities";
// import Keys from "./Dashboard/Keys";
// import Inventory from "./Dashboard/Inventory";
// import Orders from "./Dashboard/Orders";
// import Payments from "./Dashboard/Payments";
// import Balances from "./Dashboard/Balance";
// import Support from "./Dashboard/Support";
// import Account from "./Dashboard/Account";
// import ActivationReport from "./Dashboard/ActivationReport";

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Navigate to="/login" />} />
//         <Route path="/login" element={<LoginPage />} />

//         {/* Dashboard with nested routes */}
//         <Route path="/dashboard/*" element={<MultiRolePanel />}>
//           <Route index element={<Dashboards />} />
//           <Route path="entities" element={<Entities />} />
//           <Route path="keys" element={<Keys />} />
//           <Route path="inventory" element={<Inventory />} />
//           <Route path="report" element={<ActivationReport />} />
//           <Route path="orders" element={<Orders />} />
//           <Route path="payments" element={<Payments />} />
//           <Route path="balances" element={<Balances />} />
//           <Route path="support" element={<Support />} />
//           <Route path="account" element={<Account />} />
//         </Route>
//       </Routes>
//     </Router>
//   );
// }

// export default App;


// Working code

// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import LoginPage from "../src/Dashboard/Login";
// import MultiRolePanel from "./pages/MultiRolePanel"; // adjust path if needed

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Default route redirects to /login */}
//         <Route path="/" element={<Navigate to="/login" />} />

//         {/* Login page */}
//         <Route path="/login" element={<LoginPage />} />

//         {/* Dashboard page */}
//         <Route path="/dashboard" element={<MultiRolePanel />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
